import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import HolidayVillageRoundedIcon from '@mui/icons-material/HolidayVillageRounded';
import MailRoundedIcon from '@mui/icons-material/MailRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import { Box, Button, Typography, useTheme } from "@mui/material";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import React, { useContext, useEffect, useState } from "react";
import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import AuthContext from "../auth/AuthProvider";
import { fetchName, fetchToken } from "../auth/Token";
import { tokens } from "../theme";

const Item = ({ title, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.primary[100],
        borderRadius: "6px",
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
    </MenuItem>
  );
};

const Sidebarr = ({ isSidebarOpen, setIsSidebarOpen }) => {
  // const apiPrivate = useApiPrivate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [user, setUser] = useState();
  const [selected, setSelected] = useState("Dashboard");
  const [society, setSociety] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading_d, setLoading_d] = useState(false);
  const [societyName, setSocietyName] = useState();
  const [personaInfo, setPersonaInfo] = useState([]);
  const navigate = useNavigate();
  const { permissions } = useContext(AuthContext);
  const [fhfh, setfhfh] = useState("");
  const [to_go, setTo_go] = useState("")



  // useEffect(()=>{
  //   if (fetchToken() === null){
  //     navigate('/')
  //   }
  // },[])
  const fetchImage = () => {
    api
      .get("/users/su", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setPersonaInfo(response.data);
        setfhfh("yes");
        setTo_go(
          response.data?.role_name === "Credit Officer"?
            "/credit-officer": 
          response.data?.role_name === "Operations Manager"?
            "/operations-manager" :
          response.data?.role_name === "Society Manager"?
            "/society-manager" :
          response.data?.role_name === "Cashier"?
            "/cashier" :
            "/dashboard"
        );
        
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // console.log(personaInfo);

  // useEffect(() => {
  // const accessToken = auth.accessToken;
  // const token = auth.accessToken
  // setUser(username)
  //   console.log(auth.accessToken)
  // }, [])

  //   var user;

  const [soc_or, setSoc_or] = useState([]);

  const fetch_soc_or = () => {
    const storedSocOr = localStorage.getItem('soc_or');
  
    if (storedSocOr) {
      setSoc_or(JSON.parse(storedSocOr));
    } else {
      api
        .get("/users/user/society", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setSoc_or(response.data);
          localStorage.setItem('soc_or', JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  

  const fetchhmm = () => {
    const storedSociety = localStorage.getItem('society');
  
    if (storedSociety) {
      setSociety(JSON.parse(storedSociety));
    } else {
      api
        .get("/association/societies/allshch", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setSociety(response.data?.Society);
          localStorage.setItem('society', JSON.stringify(response.data?.Society));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  

  useEffect(() => {
    if (fhfh === "yes") {
      console.log("");
    } else {
      fetchImage();
    }
  }, [fhfh]);

  useEffect(() => {
    fetchhmm();
    setUser(fetchName());
    fetch_soc_or();
  }, []);

  const handleClick = (id) => {
    setOpen(true);
    fetchImage();
    fetchhmm();
  };

  const createSociety = () => {
    setLoading_d(true);
    api
      .post(`/association/create/society/${societyName}`, society, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        setSocietyName("");
        handleClose();
        setOpen(false);
        fetchImage();
        fetchhmm();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        setLoading_d(false);
      });
  };

  const blockam = () => {
    toast.warning("Not Allowed");
  };

  const handleClose = () => {
    setSocietyName("");
    setOpen(false);
  };

  return (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          background: `${colors.primary[100]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
      }}
    >
      <Box sx={{ position: "fixed" }}>
        <Sidebar collapsed={isSidebarOpen}>
          <Menu iconShape="square">
            {/* LOGO AND MENU ICON */}

            {!isSidebarOpen && (
              <Box sx={{ mb: "25px" }}>
                <Box textAlign="center">
                  <Typography
                    variant="h4"
                    color={colors.grey[100]}
                    sx={{ m: "10px 0 0 0" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>{user}</b>
                  </Typography>
                </Box>
              </Box>
            )}

            <Box paddingLeft={isSidebarOpen ? undefined : "5%"}>
              <Link style={{ textDecoration: "none" }} to={to_go}>
                <Item
                  title={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Dashboard</b>
                    </Typography>
                  }
                  icon={<DashboardRoundedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
              </Link>
              <SubMenu
                onClick={() => setIsSidebarOpen(false)}
                label={
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Societies</b>
                  </Typography>
                }
              >
                {permissions && permissions.create_society === true ? (
                  <Chip
                    label="Build Society"
                    sx={{
                      borderRadius: 7,
                      ml: 9,
                      mt: 2,
                      mb: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "#2b2d42",
                      color: "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                    onClick={handleClick}
                  />
                ) : null}
                <Box
                  sx={{
                    maxHeight: "35vh",
                    overflowY: "auto",
                    "&::-webkit-scrollbar": {
                      width: "10px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#888",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#555",
                    },
                  }}
                >
                  {/* make it show only the societies linked */}
                  {society.map((item) => {
                    const isAllowed = soc_or.Soc === item.id || soc_or.Soc === 0 || soc_or.soc2 === item.id || soc_or.soc3 === item.id;
                    return (
                      <Link
                        style={{ textDecoration: "none" }}
                        key={item.id}
                        to={isAllowed ? `/allassociationKind/${item.id}` : "#"}
                        onClick={!isAllowed ? blockam : undefined}
                      >
                        <Item
                          title={
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{item.society}</b>
                            </Typography>
                          }
                          icon={<HolidayVillageRoundedIcon />}
                          selected={selected}
                          setSelected={setSelected}
                        />
                      </Link>
                    )
                    })}
                </Box>
              </SubMenu>

              {/* {permissions && permissions.create_member === true ? (
                <>
                {
                  personaInfo?.role_name === "Supervisors"?
            null:
            <SubMenu
                  onClick={() => setIsSidebarOpen(false)}
                  label={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Manage Members</b>
                    </Typography>
                  }
                >
                  
                  <Link style={{ textDecoration: "none" }} to="/member">
                    <Item
                      title={
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Add Members</b>
                        </Typography>
                      }
                      to="member"
                      icon={<PersonAddAlt1RoundedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </Link>
                  <Link style={{ textDecoration: "none" }} to="/members">
                    <Item
                      title={
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Members</b>
                        </Typography>
                      }
                      icon={<GroupsRoundedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </Link>
                </SubMenu>
                }
                </>
              ) : (
                <Link style={{ textDecoration: "none" }} to="/members">
                  <Item
                    title={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Members</b>
                      </Typography>
                    }
                    icon={<GroupsRoundedIcon />}
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>
              )} */}
          {
            personaInfo?.role_name === "Supervisors"?
            null
            :
              <Link style={{ textDecoration: "none" }} to="/accounts">
                <Item
                  title={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Accounts</b>
                    </Typography>
                  }
                  to="/accounts"
                  icon={<AccountBalanceRoundedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
              </Link>
          }
          
          {
            personaInfo?.team_member === false?
            null
            :
              <Link style={{ textDecoration: "none" }} to="/my-teams">
                <Item
                  title={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>My Teams</b>
                    </Typography>
                  }
                  to="/my-teams"
                  icon={<GroupsRoundedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
              </Link>
          }
          
              {/* {personaInfo && personaInfo?.role_name === "Administrator" ? (

                <Link style={{ textDecoration: "none" }} to="/users">
                  <Item
                    title={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Manage Users</b>
                      </Typography>
                    }
                    to="/users"
                    icon={<BadgeRoundedIcon />}
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>
              ) : null} */}

            {
              personaInfo?.role_name === "Supervisors"?
              null:
              <Link style={{ textDecoration: "none" }} to="/inbox">
                <Item
                  title={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>My Inbox</b>
                    </Typography>
                  }
                  to="/inbox"
                  icon={<MailRoundedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
              </Link>
            }
              {(personaInfo && personaInfo?.username === "Afrifa Yaw") ||
              (personaInfo && personaInfo?.username === "developer") ? (
                <Link style={{ textDecoration: "none" }} to="/settings">
                  <Item
                    title={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Settings</b>
                      </Typography>
                    }
                    to="/settings"
                    icon={<SettingsRoundedIcon />}
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>
              ) : null}

              {(personaInfo && personaInfo?.username === "Afrifa Yaw") ||
              (personaInfo && personaInfo?.username === "developer") ? (
                <Link style={{ textDecoration: "none" }} to="/kpee">
                  <Item
                    title={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Kpee</b>
                      </Typography>
                    }
                    to="/kpee"
                    icon={<ReceiptRoundedIcon />}
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>
              ) : null}
            </Box>
          </Menu>
        </Sidebar>
      </Box>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            Build Society
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              You will be able to Register new Savings Groups after the setup.
            </Typography>
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="society"
            name="society"
            label="Society Name"
            onChange={(e) => setSocietyName(e.target.value)}
            value={societyName}
            type="text"
            fullWidth
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            size="small"
            color="error"
            variant="contained"
            sx={{
              borderRadius: "7px",
              boxShadow:
                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={createSociety}
            size="small"
            color="success"
            variant="contained"
            sx={{
              borderRadius: "7px",
              boxShadow:
                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
            }}
            disabled={loading_d}
          >
            Build
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Sidebarr;
